import { render, staticRenderFns } from "./ProblemCode.vue?vue&type=template&id=8de1424a&scoped=true&"
import script from "./ProblemCode.vue?vue&type=script&lang=js&"
export * from "./ProblemCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de1424a",
  null
  
)

export default component.exports